<template>
    <div class="w-100">
        <div class="card p-3 mb-3 mt-2">
            <p class="mb-5">
                <strong>Bitte beachte:</strong>
            </p>
            <p>
                Du hast die Möglichkeit den Kurs in einer Gesamtzahlung zu bezahlen oder in einer Ratenzahlung zu je
                entweder 3, 6 oder 12 Raten.
                <br/>Bei der Ratenzahlung ist zu beachten, dass, abhängig von der Raten-Laufzeit, eine
                Bearbeitungsgebühr auf den Gesamtpreis aufgeschlagen wird.
            </p>
            <p>
                <strong>Hinweis: Die erste Zahlung erfolgt online. Für alle weiteren Zahlungen erhältst eine seperate
                    Rechnung, welche dann ebenfalls </strong>
            </p>
        </div>
        <div clasS="card p-3 mb-3">
            <div class="form-check">
                <input class="form-check-input" id="onetimePayment" type="checkbox" v-model="onetimePayment"/>
                <label for="onetimePayment" class="form-check-label font-weight-bold">Ich möchte den Kurs in einer
                    einzigen Zahlung,
                    komplett Online bezahlen.</label>
            </div>
        </div>
        <div class="card p-3" v-if="!onetimePayment">
            <p class="mb-5">
                <strong>Bitte wählen Sie die Laufzeit der Ratenzahlung:</strong>
            </p>
            <vue-slider v-model="installments" :piecewise="true" :data="allInstallments"></vue-slider>
            <p class="font-weight-bold">{{
                    $t('strings.frontend.checkout.installment', {
                        installments: installments,
                        installment: installment.toFixed(2),
                        currency: '€'
                    })
                }}</p>
            <p class="text-danger">
                {{ $t('strings.frontend.checkout.feedescription', {percent: interest}) }}
            </p>
            <p class="font-weight-bold text-danger" v-if="installments > 0">
                Die Erste Rate ist sofort fällig und wird online bezahlt. Bitte wähle dazu oben deine gewünschte
                Bezahlart aus.
            </p>
            <input type="hidden" name="installments" v-model="installments"/>
            <input type="hidden" name="installment" v-model="installment"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        price: Number,
        installmentType: String
    },
    data: function () {
        return {
            installments: 0,
            allInstallments: [0, 3, 6, 12],
            onetimePayment: false
        }
    },
    watch: {
        interest: function () {
            this.$emit('interestChange', this.interest);
        },
        onetimePayment: function () {
            this.$emit('onetimePaymentChange', this.onetimePayment)
        },
        installment: function () {
            this.$emit('installmentChange', this.installment)
        }
    },
    computed: {
        interest: function () {
            if (this.loanAmount === 0 || this.onetimePayment || this.installmentType === 'fixed_3' || this.installmentType === 'none') {
                return 0;
            }
            if (this.installments <= 1) {
                return 0;
            }
            if (this.installments < 6) {
                return 5;
            }
            if (this.installments < 12) {
                return 10;
            }
            return 15;
        },
        loanAmount: function () {
            return !this.onetimePayment ? this.price : 0;
        },
        installment: function () {
            if (this.installments === 0) {
                return 0;
            }
            return this.loanAmount * (1 + this.interest / 100) / this.installments;
        }
    },
    mounted: function () {
        if (this.installmentType === 'fixed_3') {
            this.installments = 3;
        }
    }
}
</script>
